import { apiClient } from './client'

export interface CapabilitiesResponse {
  success: boolean
  data: {
    capabilities: string[]
  }
}

export interface CapabilityMutationResponse {
  success: boolean
  data: {
    message: string
    capabilities: string[]
  }
}

export interface CheckCapabilityResponse {
  success: boolean
  data: {
    capability: string
    hasCapability: boolean
  }
}

export interface AddCapabilityRequest {
  capability: string
}

export interface SetCapabilitiesRequest {
  capabilities: string[]
}

export const hospitalCapabilitiesApi = {
  getCapabilities: async (hospitalId: string): Promise<CapabilitiesResponse> => {
    const response = await apiClient.get<CapabilitiesResponse>(
      `/hospitals/${hospitalId}/capabilities`
    )
    return response.data
  },

  addCapability: async (
    hospitalId: string,
    data: AddCapabilityRequest
  ): Promise<CapabilityMutationResponse> => {
    const response = await apiClient.post<CapabilityMutationResponse>(
      `/hospitals/${hospitalId}/capabilities`,
      data
    )
    return response.data
  },

  removeCapability: async (
    hospitalId: string,
    capability: string
  ): Promise<CapabilityMutationResponse> => {
    const response = await apiClient.delete<CapabilityMutationResponse>(
      `/hospitals/${hospitalId}/capabilities/${capability}`
    )
    return response.data
  },

  setCapabilities: async (
    hospitalId: string,
    data: SetCapabilitiesRequest
  ): Promise<CapabilityMutationResponse> => {
    const response = await apiClient.put<CapabilityMutationResponse>(
      `/hospitals/${hospitalId}/capabilities`,
      data
    )
    return response.data
  },

  checkCapability: async (
    hospitalId: string,
    capability: string
  ): Promise<CheckCapabilityResponse> => {
    const response = await apiClient.get<CheckCapabilityResponse>(
      `/hospitals/${hospitalId}/capabilities/${capability}/check`
    )
    return response.data
  },
}
